import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  stationFences: [],
  allStationFences: [],
  totalPages: 0,
  totalRecords: 0,
  stationFence: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_96: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_StationFences(state, stationFences) {
    state.stationFences = stationFences.items;
    state.totalPages = stationFences.totalPages;
    state.totalRecords = stationFences?.totalRecords ?? 0;
  },
  SET_AllStationFences(state, stationFences) {
    state.allStationFences = stationFences;
  },
  SET_StationFence(state, stationFence) {
    state.stationFence = stationFence;
  },
};
const actions = {
  errorStationFence({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllStationFences({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/StationFences/All?StationId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllStationFences', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationFence', error);
      });
  },
  getStationFencesWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, cityId },
  ) {
    var url = '/StationFences/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_StationFences', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationFence', error);
      });
  },
  addStationFence({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/StationFences', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationFence', error);
      });
  },
  getStationFence({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/StationFences/ById?stationFenceId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_StationFence', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationFence', error);
      });
  },
  editStationFence({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/StationFences/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationFence', error);
      });
  },
  deleteStationFence({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        // '/StationFences/Remove?stationFenceId=' + id,
        '/StationFences/Remove?stationId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationFence', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
